// Controla o splash de carregamento definido em public/index.html (#muven-splash)

const SPLASH_ID = 'muven-splash';
const LEAVE_FALLBACK_TIME = 900;

export const SPLASH_STEPS = [
  'Verificando sua sessão',
  'Carregando seu perfil',
  'Buscando suas contas',
  'Preparando suas lojas',
];

function getSplash(): HTMLElement | null {
  return document.getElementById(SPLASH_ID);
}

export function setSplashStep(step: number): void {
  const splash = getSplash();

  if (!splash) {
    return;
  }

  // reserva o trecho final da barra para a saida
  const progress = 0.15 + (step / SPLASH_STEPS.length) * 0.75;
  splash.style.setProperty('--progress', `${progress}`);

  const status = splash.querySelector('.splash-status');

  if (status && SPLASH_STEPS[step]) {
    status.classList.remove('is-swapping');
    // forca reflow para reiniciar a animacao de troca
    (status as HTMLElement).getBoundingClientRect();
    status.textContent = SPLASH_STEPS[step];
    status.classList.add('is-swapping');
  }
}

export function dismissSplash(): Promise<void> {
  const splash = getSplash();

  if (!splash) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    let done = false;

    const finish = () => {
      if (done) {
        return;
      }

      done = true;
      splash.removeEventListener('transitionend', onTransitionEnd);
      splash.remove();
      resolve();
    };

    const onTransitionEnd = (event: TransitionEvent) => {
      if (event.target === splash && event.propertyName === 'opacity') {
        finish();
      }
    };

    splash.style.setProperty('--progress', '1');
    splash.setAttribute('aria-busy', 'false');
    splash.addEventListener('transitionend', onTransitionEnd);
    splash.classList.add('is-leaving');

    setTimeout(finish, LEAVE_FALLBACK_TIME);
  });
}
